var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal2",
    {
      attrs: {
        id: "awaiting-message-details",
        title: "Talep Detay / " + _vm.getTicketPlatform(),
        "show-footer": false,
      },
      on: { cancel: _vm.closeModal },
    },
    [
      _vm.ticket.returnType
        ? _c("div", { staticClass: "information-banner" }, [
            _c("i", { staticClass: "material-icons" }, [_vm._v("info")]),
            _vm._v(" "),
            _vm.ticket.returnType === "email" || !_vm.ticket.returnType
              ? _c("span", [
                  _vm._v(
                    "\n            Bu kişi e-posta ile cevaplanmak istiyor\n        "
                  ),
                ])
              : _vm.ticket.returnType === "whatsapp"
              ? _c("span", [
                  _vm._v(
                    "\n            Bu kişi WhatsApp üzerinden cevap bekliyor.\n            "
                  ),
                  _c(
                    "a",
                    {
                      attrs: { href: "javascript:void(0)" },
                      on: { click: _vm.showWhatsappChatStarter },
                    },
                    [_vm._v("WhatsApp chat başlatmak için tıklayınız")]
                  ),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "ticket-status-wrapper" },
        [
          _c("span", [_vm._v("Talep İlerleme Durumu")]),
          _vm._v(" "),
          _c("TicketStatusSwitcher", {
            attrs: {
              currentStatus: _vm.ticket.status,
              statusList: _vm.statusList,
            },
            on: {
              "update-status": function (status) {
                return _vm.changeTicketStatus(_vm.ticket._id, status)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "user-info-profile",
          on: { click: _vm.viewContactProfile },
        },
        [
          _c(
            "div",
            { staticClass: "profile-header" },
            [
              _c("ContactAvatar", {
                key: _vm.ticket.visitor._id,
                attrs: {
                  contact: _vm.ticket.visitor,
                  badge: true,
                  "badge-type": "visitor-offline",
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "contact-profile-info" }, [
                _c("div", { staticClass: "contact-profile-fullname" }, [
                  _vm._v(_vm._s(_vm.ticket.visitor.fullname)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "platform-info" }, [
                  _c("div", { staticClass: "platform-name" }, [
                    _c(
                      "div",
                      { staticClass: "platform-icon-wrapper" },
                      [
                        _vm.ticket.visitor.platform === "whatsapp"
                          ? _c("WhatsappIcon", {
                              staticClass: "option-icon",
                              attrs: { color: "#25D366" },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.ticket.visitor.platform === "telegram"
                          ? _c("TelegramIcon", { staticClass: "option-icon" })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.ticket.visitor.platform === "messenger"
                          ? _c("MessengerIcon", { staticClass: "option-icon" })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.ticket.visitor.platform === "web"
                          ? _c("webIcon", {
                              staticClass: "option-icon",
                              attrs: { color: "black;" },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.ticket.visitor.platform === "email"
                          ? _c("mailIcon", { staticClass: "option-icon" })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.ticket.visitor.platform === "meta-leads"
                          ? _c("MetaIcon", { staticClass: "option-icon" })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.ticket.visitor.platform === "instagram"
                          ? _c("InstagramIcon", {
                              staticClass: "option-icon",
                              attrs: { "special-background-mode": "" },
                            })
                          : _vm._e(),
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.getPlatformName()) +
                            "\n                        "
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "value-item" }, [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("email"),
                      ]),
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.getEmailAddress() || "-") +
                          "\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "value-item",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.showStartChat.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("phone"),
                        ]),
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.getPhoneNumber() || "-") +
                            "\n                        "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.ticket.visitor.platform === "whatsapp"
                    ? _c(
                        "div",
                        {
                          staticClass: "whatsapp-number",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              _vm.showWhatsappChatStarterModal = true
                            },
                          },
                        },
                        [
                          _c("a", { attrs: { href: "javascript:void(0)" } }, [
                            _vm._v(_vm._s(_vm.ticket.visitor.whatsappNumber)),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]),
              ]),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _vm.selectedHistory.type === "osr"
        ? _c(
            "div",
            [
              _c("div", { staticClass: "ticket-message" }, [
                _c("strong", [_vm._v("Talep Mesajı")]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.selectedHistory.messages))]),
              ]),
              _vm._v(" "),
              _c("quill-editor", {
                attrs: { options: _vm.editorOption },
                model: {
                  value: _vm.responseText,
                  callback: function ($$v) {
                    _vm.responseText = $$v
                  },
                  expression: "responseText",
                },
              }),
              _vm._v(" "),
              _c(
                "a-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { defaultValue: null },
                  model: {
                    value: _vm.selectedSenderMailId,
                    callback: function ($$v) {
                      _vm.selectedSenderMailId = $$v
                    },
                    expression: "selectedSenderMailId",
                  },
                },
                [
                  _c(
                    "a-select-option",
                    { attrs: { selected: true, value: "null" } },
                    [_vm._v("👉Select Email Sender...")]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.senderMails, function (senderMail) {
                    return _c(
                      "a-select-option",
                      {
                        key: senderMail.mail,
                        attrs: { value: senderMail._id },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(senderMail.mail) +
                            "\n            "
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-4" },
                [
                  _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _vm.isSupsisMail()
                        ? _c("div", { staticClass: "mail-warning" }, [
                            _c("div", { staticClass: "text" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    "Bu mail adresi ile gönderimlerde maile verilen yanıtları alamazsınız!"
                                  ) +
                                  "\n                    "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "link",
                                on: {
                                  click: function ($event) {
                                    return _vm.$router.replace(
                                      "/integrations/mail"
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        Mail adresi eklemek için tıklayınız\n                    "
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "SupsisButton",
                        {
                          staticClass: "float-right",
                          attrs: { ghost: "" },
                          on: { click: _vm.closeModal },
                        },
                        [
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("message.cancel")) +
                                "\n                    "
                            ),
                          ],
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "SupsisButton",
                        {
                          staticClass: "float-right mr-2",
                          attrs: { primary: "", disabled: _vm.responseSending },
                          on: { click: _vm.sendResponseAndClose },
                        },
                        [
                          !_vm.responseSending
                            ? [_vm._v(" Cevap Gönder ve Ticket'ı Kapat ")]
                            : [
                                _c("font-awesome-icon", {
                                  attrs: { icon: "spinner", spin: "" },
                                }),
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.$t("message.sending")) +
                                    "...\n                    "
                                ),
                              ],
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "SupsisButton",
                        {
                          staticClass: "float-right mr-2",
                          attrs: {
                            warning: "",
                            disabled: _vm.responseSending,
                            ghost: "",
                          },
                          on: { click: _vm.closeTicket },
                        },
                        [
                          _vm._v(
                            "\n                    Ticket'ı Kapat\n                "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm.selectedHistory.type === "automation"
        ? _c(
            "div",
            [
              _c("div", { staticClass: "ticket-message" }, [
                _c("strong", [_vm._v("Talep Mesajı")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(_vm._s(_vm.selectedHistory.ticket.ticketMessage)),
                ]),
              ]),
              _vm._v(" "),
              _c("quill-editor", {
                attrs: { options: _vm.editorOption },
                model: {
                  value: _vm.responseText,
                  callback: function ($$v) {
                    _vm.responseText = $$v
                  },
                  expression: "responseText",
                },
              }),
              _vm._v(" "),
              _c(
                "a-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { defaultValue: null },
                  model: {
                    value: _vm.selectedSenderMailId,
                    callback: function ($$v) {
                      _vm.selectedSenderMailId = $$v
                    },
                    expression: "selectedSenderMailId",
                  },
                },
                [
                  _c(
                    "a-select-option",
                    { attrs: { selected: true, value: "null" } },
                    [_vm._v("👉Select Email Sender...")]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.senderMails, function (senderMail) {
                    return _c(
                      "a-select-option",
                      {
                        key: senderMail.mail,
                        attrs: { value: senderMail._id },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(senderMail.mail) +
                            "\n            "
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-4" },
                [
                  _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _vm.isSupsisMail()
                        ? _c("div", { staticClass: "mail-warning" }, [
                            _c("div", { staticClass: "text" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    "Bu mail adresi ile gönderimlerde maile verilen yanıtları alamazsınız!"
                                  ) +
                                  "\n                    "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "link",
                                on: {
                                  click: function ($event) {
                                    return _vm.$router.replace(
                                      "/integrations/mail"
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        Mail adresi eklemek için tıklayınız\n                    "
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "SupsisButton",
                        {
                          staticClass: "float-right",
                          attrs: { ghost: "" },
                          on: { click: _vm.closeModal },
                        },
                        [
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("message.cancel")) +
                                "\n                    "
                            ),
                          ],
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "SupsisButton",
                        {
                          staticClass: "float-right mr-2",
                          attrs: { primary: "", disabled: _vm.responseSending },
                          on: { click: _vm.sendResponseAndClose },
                        },
                        [
                          !_vm.responseSending
                            ? [_vm._v(" Cevap Gönder ve Ticket'ı Kapat ")]
                            : [
                                _c("font-awesome-icon", {
                                  attrs: { icon: "spinner", spin: "" },
                                }),
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.$t("message.sending")) +
                                    "...\n                    "
                                ),
                              ],
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "SupsisButton",
                        {
                          staticClass: "float-right mr-2",
                          attrs: {
                            warning: "",
                            disabled: _vm.responseSending,
                            ghost: "",
                          },
                          on: { click: _vm.closeTicket },
                        },
                        [
                          _vm._v(
                            "\n                    Ticket'ı Kapat\n                "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c("div", [
            _vm.ticket.type !== "form"
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "flex-direction": "column",
                    },
                  },
                  [
                    _vm.filteredMessages.length
                      ? _c(
                          "div",
                          {
                            directives: [
                              { name: "chat-scroll", rawName: "v-chat-scroll" },
                            ],
                            staticClass: "waiting-ticket-messages",
                          },
                          [
                            _c("MessageList", {
                              attrs: {
                                contextMenuVisable: false,
                                "always-scroll-to-bottom": false,
                                colors: _vm.colors,
                                messages: _vm.getMessages(),
                                participants: _vm.getParticipants(),
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("quill-editor", {
                      attrs: { options: _vm.editorOption },
                      model: {
                        value: _vm.responseText,
                        callback: function ($$v) {
                          _vm.responseText = $$v
                        },
                        expression: "responseText",
                      },
                    }),
                    _vm._v(" "),
                    ![
                      "instagram-comment",
                      "instagram-mention",
                      "page-comment",
                      "trendyol",
                    ].includes(_vm.ticket.type)
                      ? _c(
                          "a-select",
                          {
                            attrs: { defaultValue: null },
                            model: {
                              value: _vm.selectedSenderMailId,
                              callback: function ($$v) {
                                _vm.selectedSenderMailId = $$v
                              },
                              expression: "selectedSenderMailId",
                            },
                          },
                          [
                            _c(
                              "a-select-option",
                              { attrs: { selected: true, value: "null" } },
                              [_vm._v("👉Select Email Sender...")]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.senderMails, function (senderMail) {
                              return _c(
                                "a-select-option",
                                {
                                  key: senderMail.mail,
                                  attrs: { value: senderMail._id },
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(senderMail.mail) +
                                      "\n                "
                                  ),
                                ]
                              )
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "actions" },
                      [
                        ["instagram-comment"].includes(_vm.ticket.type)
                          ? _c("a-switch", {
                              attrs: {
                                name: "hidden",
                                "checked-children": "Hidden Comment",
                                "un-checked-children": "Unhidden Comment",
                              },
                              model: {
                                value: _vm.hidden,
                                callback: function ($$v) {
                                  _vm.hidden = $$v
                                },
                                expression: "hidden",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "actions" },
                      [
                        _c(
                          "SupsisButton",
                          {
                            attrs: { ghost: "" },
                            on: { click: _vm.closeModal },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$t("message.cancel")) +
                                "\n                "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        ![
                          "instagram-comment",
                          "instagram-mention",
                          "page-comment",
                          "trendyol",
                        ].includes(_vm.ticket.type)
                          ? _c(
                              "SupsisButton",
                              {
                                attrs: {
                                  primary: "",
                                  disabled: _vm.responseSending,
                                },
                                on: { click: _vm.sendResponse },
                              },
                              [
                                _vm.responseSending
                                  ? _c(
                                      "span",
                                      [
                                        _c("font-awesome-icon", {
                                          attrs: { icon: "spinner", spin: "" },
                                        }),
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(_vm.$t("message.sending")) +
                                            "...\n                    "
                                        ),
                                      ],
                                      1
                                    )
                                  : _c("span", [
                                      _vm._v(_vm._s(_vm.$t("message.send"))),
                                    ]),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        ["instagram-comment"].includes(_vm.ticket.type)
                          ? _c(
                              "SupsisButton",
                              {
                                attrs: {
                                  danger: "",
                                  disabled: _vm.responseSending,
                                },
                                on: {
                                  click: function () {
                                    return _vm.deleteComment()
                                  },
                                },
                              },
                              [
                                _vm.responseSending
                                  ? _c(
                                      "span",
                                      [
                                        _c("font-awesome-icon", {
                                          attrs: { icon: "spinner", spin: "" },
                                        }),
                                        _vm._v(
                                          "\n                        Deleting...\n                    "
                                        ),
                                      ],
                                      1
                                    )
                                  : _c("span", [
                                      _vm._v("Delete Comment and Close"),
                                    ]),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        [
                          "instagram-comment",
                          "instagram-mention",
                          "page-comment",
                        ].includes(_vm.ticket.type)
                          ? _c(
                              "SupsisButton",
                              {
                                attrs: {
                                  primary: "",
                                  disabled: _vm.responseSending,
                                },
                                on: {
                                  click: function () {
                                    return _vm.sendAsComment(false)
                                  },
                                },
                              },
                              [
                                _vm.responseSending
                                  ? _c(
                                      "span",
                                      [
                                        _c("font-awesome-icon", {
                                          attrs: { icon: "spinner", spin: "" },
                                        }),
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(_vm.$t("message.sending")) +
                                            "...\n                    "
                                        ),
                                      ],
                                      1
                                    )
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("message.replyAsAComment")
                                        )
                                      ),
                                    ]),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        ["instagram-comment", "page-comment"].includes(
                          _vm.ticket.type
                        )
                          ? _c(
                              "SupsisButton",
                              {
                                attrs: {
                                  primary: "",
                                  disabled: _vm.responseSending,
                                },
                                on: {
                                  click: function () {
                                    return _vm.sendAsComment(true)
                                  },
                                },
                              },
                              [
                                _vm.responseSending
                                  ? _c(
                                      "span",
                                      [
                                        _c("font-awesome-icon", {
                                          attrs: { icon: "spinner", spin: "" },
                                        }),
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(_vm.$t("message.sending")) +
                                            "...\n                    "
                                        ),
                                      ],
                                      1
                                    )
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.$t("message.ReplyAsAPm"))
                                      ),
                                    ]),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        ["trendyol"].includes(_vm.ticket.type)
                          ? _c(
                              "SupsisButton",
                              {
                                attrs: {
                                  primary: "",
                                  disabled: _vm.responseSending,
                                },
                                on: { click: _vm.replyTrendyolQuestion },
                              },
                              [
                                _vm.responseSending
                                  ? _c(
                                      "span",
                                      [
                                        _c("font-awesome-icon", {
                                          attrs: { icon: "spinner", spin: "" },
                                        }),
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(_vm.$t("message.sending")) +
                                            "...\n                    "
                                        ),
                                      ],
                                      1
                                    )
                                  : _c("span", [
                                      _vm._v("Yanıtı Gönder ve Kapat"),
                                    ]),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm.ticket.type === "form"
              ? _c(
                  "div",
                  [
                    _c(
                      "div",
                      { staticClass: "form-content" },
                      [
                        _c("TicketInboxContents", {
                          attrs: { submissionId: _vm.ticket.formSubmission },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("quill-editor", {
                      attrs: { options: _vm.editorOption },
                      model: {
                        value: _vm.responseText,
                        callback: function ($$v) {
                          _vm.responseText = $$v
                        },
                        expression: "responseText",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "a-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { defaultValue: null },
                        model: {
                          value: _vm.selectedSenderMailId,
                          callback: function ($$v) {
                            _vm.selectedSenderMailId = $$v
                          },
                          expression: "selectedSenderMailId",
                        },
                      },
                      [
                        _c(
                          "a-select-option",
                          { attrs: { selected: true, value: "null" } },
                          [_vm._v("👉Select Email Sender...")]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.senderMails, function (senderMail) {
                          return _c(
                            "a-select-option",
                            {
                              key: senderMail.mail,
                              attrs: { value: senderMail._id },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(senderMail.mail) +
                                  "\n                "
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "mt-4" },
                      [
                        _c(
                          "b-col",
                          { attrs: { md: "12" } },
                          [
                            _vm.isSupsisMail()
                              ? _c("div", { staticClass: "mail-warning" }, [
                                  _c("div", { staticClass: "text" }, [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          "Bu mail adresi ile gönderimlerde maile verilen yanıtları alamazsınız!"
                                        ) +
                                        "\n                        "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "link",
                                      on: {
                                        click: function ($event) {
                                          return _vm.$router.replace(
                                            "/integrations/mail"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Mail adresi eklemek için tıklayınız\n                        "
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "SupsisButton",
                              {
                                staticClass: "float-right",
                                attrs: { ghost: "" },
                                on: { click: _vm.closeModal },
                              },
                              [
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.$t("message.cancel")) +
                                      "\n                        "
                                  ),
                                ],
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "SupsisButton",
                              {
                                staticClass: "float-right mr-2",
                                attrs: {
                                  primary: "",
                                  disabled: _vm.responseSending,
                                },
                                on: { click: _vm.sendResponseAndClose },
                              },
                              [
                                !_vm.responseSending
                                  ? [_vm._v(" Cevap Gönder ve Ticket'ı Kapat")]
                                  : [
                                      _c("font-awesome-icon", {
                                        attrs: { icon: "spinner", spin: "" },
                                      }),
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.$t("message.sending")) +
                                          "...\n                        "
                                      ),
                                    ],
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "SupsisButton",
                              {
                                staticClass: "float-right mr-2",
                                attrs: {
                                  warning: "",
                                  disabled: _vm.responseSending,
                                  ghost: "",
                                },
                                on: { click: _vm.closeTicket },
                              },
                              [
                                _vm._v(
                                  "\n                        Ticket'ı Kapat\n                    "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _c(
                  "div",
                  [
                    _c("b-alert", { attrs: { show: "", variant: "info" } }, [
                      _vm._v(_vm._s(_vm.$t("message.chatNotFound"))),
                    ]),
                  ],
                  1
                ),
          ]),
      _vm._v(" "),
      _vm.showWhatsappChatStarterModal
        ? _c(
            "Modal2",
            {
              attrs: { title: "WhatsApp Chat Başlat", showFooter: false },
              on: {
                cancel: function ($event) {
                  _vm.showWhatsappChatStarterModal = false
                },
              },
            },
            [
              _c("WhatsappChatStarter", {
                attrs: {
                  "default-phone-number": _vm.getPhoneNumber(),
                  "channel-override": "",
                  "phone-number-override": "",
                  "default-email": _vm.ticket.visitor.email,
                  "default-name":
                    _vm.ticket.visitor.name || _vm.ticket.visitor.fullname,
                },
                on: {
                  close: function ($event) {
                    _vm.showWhatsappChatStarterModal = false
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "navigation-buttons" },
        [
          _c(
            "SupsisButton",
            {
              attrs: { ghost: "" },
              on: {
                click: function ($event) {
                  return _vm.navigate(-1)
                },
              },
            },
            [
              _c("span", { staticClass: "keyboard-shortcut" }, [
                _vm._v("Ctrl+←"),
              ]),
              _vm._v("\n            Önceki\n        "),
            ]
          ),
          _vm._v(" "),
          _c(
            "SupsisButton",
            {
              attrs: { ghost: "" },
              on: {
                click: function ($event) {
                  return _vm.navigate(1)
                },
              },
            },
            [
              _c("span", { staticClass: "keyboard-shortcut" }, [
                _vm._v("Ctrl+→"),
              ]),
              _vm._v("\n            Sonraki\n        "),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }